module.exports = __webpack_public_path__ + "mr.cb629791.svg";